import Vue from 'vue'
import App from './App.vue'
import router from '@/js_router/router.js'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/css_assets/main.css' // 全局样式表
import $http from '@/js_util/axios.js' // 引入定义的axios工具
import myVuex from "@/js_store/myVuex.js"; // 引入vuex管理全局存储
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
import BaiduMap from 'vue-baidu-map' // 全局引入百度地图
import {consumeBalance} from "@/js_util/my_util";

Vue.use(BaiduMap, { // 使用百度地图
    ak: 'kU1NefOuMEittm0ijhFnwTpb2ms39Zbw'
})


Vue.use(mavonEditor) // 挂载
Vue.prototype.$http = $http //引入util/axios.js暴露的$http来使用
Vue.prototype.consumeBalance = consumeBalance //引入util/axios.js暴露的$http来使用

Vue.config.productionTip = false
Vue.use(ElementUI, {size: 'mini'}) // 挂载elementUI

new Vue({
    router, myVuex, render: h => h(App)
}).$mount('#app')

/*导入Vue框架：import Vue from 'vue'
导入App组件：import App from './App.vue'
导入路由配置：import router from '@/js_router/router.js'
导入ElementUI组件库：import ElementUI from 'element-ui'
导入ElementUI的样式文件：import 'element-ui/lib/theme-chalk/index.css'
导入全局样式表：import '@/css_assets/main.css'
导入自定义的axios工具：import $http from '@/js_util/axios.js'
导入自定义的Vuex管理全局存储：import myVuex from "@/js_store/myVuex.js"
导入mavonEditor编辑器：import mavonEditor from 'mavon-editor'
导入mavonEditor的样式文件：import 'mavon-editor/dist/css/index.css'
使用mavonEditor插件：Vue.use(mavonEditor)
将挂载到原型上，以便在组件中使用：
http挂载到Vue原型上，以便在组件中使用：‘Vue.prototype.http = $http`
关闭生产环境的提示信息：Vue.config.productionTip = false
使用ElementUI插件，并设置其大小为mini：Vue.use(ElementUI, {size: 'mini'})
创建一个新的Vue实例，并将App组件渲染到id为app的DOM元素上：new Vue({router, myVuex, render: h => h(App)}).$mount('#app')*/
